// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"283":"1970eeac","343":"36a36015","736":"12dcb793"}[chunkId] + ".css";
};